import React from "react";
export default function Footer() {
  return (
    <>
      <footer id="footer" className="footer">
        <div className="container">
          <div className="copyright text-center ">
            <p>
              © <span>Copyright</span>
              <strong className="px-1 sitename"></strong>{"All Rights Reserved"}
            </p>
          </div>
          <div className="social-links d-flex justify-content-center">
            <a href="tel:+255 621 215 286">
              <i className="bi bi-phone"></i>
            </a>
            <a href="mailto:francebahati89@gmail.com">
              <i className="bi bi-envelope"></i>
            </a>

            <a
              href="https://github.com/francisbahati"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="bi bi-github"></i>
            </a>
          </div>
          <div className="credits">
            Designed by <a href="">Bahati</a> 
          </div>
        </div>
      </footer>
    </>
  );
}
